import "./index.scss";

/**
 * Fixed bottom bar with plan summary and the submit button.
 *
 * Props:
 *   planName   {string}   — selected plan display name
 *   coverage   {string}   — selected option label
 *   cost       {string}   — formatted total premium string
 *   isFormValid {boolean} — enables / disables the button
 *   isSubmitting {boolean}— shows spinner while API call is running
 *   onActivate {Function} — called when the button is clicked
 */
const Footer = ({
  planName,
  coverage,
  cost,
  isFormValid = false,
  isSubmitting = false,
  onActivate,
}) => {
  const disabled = !isFormValid || isSubmitting;

  return (
    <div className="footer-bar">
      <div className="footer-bar__info">
        <div className="footer-bar__item">
          <span className="footer-bar__label">Selected Plan</span>
          <span className="footer-bar__value">
            {planName || "Not Selected"}
          </span>
        </div>
        <div className="footer-bar__divider" />
        <div className="footer-bar__item">
          <span className="footer-bar__label">Total Coverage</span>
          <span className="footer-bar__value">{coverage || "₹ 00"}</span>
        </div>
        <div className="footer-bar__divider" />
        <div className="footer-bar__item">
          <span className="footer-bar__label">Total Premium</span>
          <span className="footer-bar__value">{cost || "₹ 00"}</span>
        </div>
      </div>

      <button
        className={`footer-bar__btn${disabled ? " footer-bar__btn--disabled" : ""}`}
        onClick={onActivate}
        disabled={disabled}
        aria-disabled={disabled}
      >
        {isSubmitting ? (
          <span className="footer-bar__spinner" aria-label="Submitting…" />
        ) : (
          "Activate Protection"
        )}
      </button>
    </div>
  );
};

export default Footer;
